// Icon Imports
import AlienIcon from './assets/emoji-alien.svg';
import BrokenheartIcon from './assets/emoji-brokenheart.svg';
import CatUnicornIcon from './assets/emoji-cat-unicorn.svg';
import CrumpetScientistIcon from './assets/emoji-crumpet-scientist.svg';
import CrumpetSnumpIcon from './assets/emoji-crumpet-snump.svg';
import DogSideeyeIcon from './assets/emoji-dog-sideeye.svg';
import FaceHearteyesIcon from './assets/emoji-face-hearteyes.svg';
import FlameIcon from './assets/emoji-flame.svg';
import HandClappingIcon from './assets/emoji-hand-clapping.svg';
import HandDownIcon from './assets/emoji-hand-down.svg';
import HandLeftIcon from './assets/emoji-hand-left.svg';
import HandNoIcon from './assets/emoji-hand-no.svg';
import HandPerfectIcon from './assets/emoji-hand-perfect.svg';
import HandRightIcon from './assets/emoji-hand-right.svg';
import HandUpIcon from './assets/emoji-hand-up.svg';
import HandYesIcon from './assets/emoji-hand-yes.svg';
import HeartBlackIcon from './assets/emoji-heart-black.svg';
import HeartBlueIcon from './assets/emoji-heart-blue.svg';
import HeartGreenIcon from './assets/emoji-heart-green.svg';
import HeartOrangeIcon from './assets/emoji-heart-orange.svg';
import HeartPinkIcon from './assets/emoji-heart-pink.svg';
import HeartRedIcon from './assets/emoji-heart-red.svg';
import HeartSparklesIcon from './assets/emoji-heart-sparkles.svg';
import HeartYellowIcon from './assets/emoji-heart-yellow.svg';
import OtterIcon from './assets/emoji-otter.svg';
import PlusoneIcon from './assets/emoji-plusone.svg';
import PoopFineIcon from './assets/emoji-poop-fine.svg';
import PoopScaredIcon from './assets/emoji-poop-scared.svg';
import RainbowIcon from './assets/emoji-rainbow.svg';
import RainbowheartIcon from './assets/emoji-rainbowheart.svg';
import RocketIcon from './assets/emoji-rocket.svg';
import SharkIcon from './assets/emoji-shark.svg';
import SlothFaceSmileIcon from './assets/emoji-sloth-face-smile.svg';
import SparklesIcon from './assets/emoji-sparkles.svg';
import StarIcon from './assets/emoji-star.svg';
import SunIcon from './assets/emoji-sun.svg';
import FaceAngryIcon from './assets/face-angry.svg';
import FaceCelebrateIcon from './assets/face-celebrate.svg';
import FaceEyesStarsIcon from './assets/face-eyes-stars.svg';
import FaceFartIcon from './assets/face-fart.svg';
import FaceFlushedIcon from './assets/face-flushed.svg';
import FaceHeartbrokenIcon from './assets/face-heartbroken.svg';
import FaceLaughingIcon from './assets/face-laughing.svg';
import FaceLaughingCryIcon from './assets/face-laughing-cry.svg';
import FaceLaughingHardIcon from './assets/face-laughing-hard.svg';
import FaceSadIcon from './assets/face-sad.svg';
import FaceSadEyesIcon from './assets/face-sad-eyes.svg';
import FaceSadTearIcon from './assets/face-sad-tear.svg';
import FaceScaredGhostIcon from './assets/face-scared-ghost.svg';
import FaceSickGreenIcon from './assets/face-sick-green.svg';
import FaceSleepyIcon from './assets/face-sleepy.svg';
import FaceSmileSweatIcon from './assets/face-smile-sweat.svg';
import FaceSmirkIcon from './assets/face-smirk.svg';
import FaceSunglassesIcon from './assets/face-sunglasses.svg';
import FaceSurprisedIcon from './assets/face-surprised.svg';
import FaceTeethUnsureIcon from './assets/face-teeth-unsure.svg';
import FaceThinkingIcon from './assets/face-thinking.svg';
import FaceTongueOutWinkIcon from './assets/face-tongue-out-wink.svg';
import FaceTongueOutYumIcon from './assets/face-tongue-out-yum.svg';
import FaceUnsureIcon from './assets/face-unsure.svg';

export type TocaIcon = keyof typeof TocaIconMap;

export const isTocaIcon = (icon?: string): icon is TocaIcon => {
    return icon !== undefined && icon in TocaIconMap;
};

export const TocaIconMap: Record<string, string> = {
    'emoji-alien': AlienIcon,
    'emoji-brokenheart': BrokenheartIcon,
    'emoji-cat-unicorn': CatUnicornIcon,
    'emoji-crumpet-scientist': CrumpetScientistIcon,
    'emoji-crumpet-snump': CrumpetSnumpIcon,
    'emoji-dog-sideeye': DogSideeyeIcon,
    'emoji-face-hearteyes': FaceHearteyesIcon,
    'emoji-flame': FlameIcon,
    'emoji-hand-clapping': HandClappingIcon,
    'emoji-hand-down': HandDownIcon,
    'emoji-hand-left': HandLeftIcon,
    'emoji-hand-no': HandNoIcon,
    'emoji-hand-perfect': HandPerfectIcon,
    'emoji-hand-right': HandRightIcon,
    'emoji-hand-up': HandUpIcon,
    'emoji-hand-yes': HandYesIcon,
    'emoji-heart-black': HeartBlackIcon,
    'emoji-heart-blue': HeartBlueIcon,
    'emoji-heart-green': HeartGreenIcon,
    'emoji-heart-orange': HeartOrangeIcon,
    'emoji-heart-pink': HeartPinkIcon,
    'emoji-heart-red': HeartRedIcon,
    'emoji-heart-sparkles': HeartSparklesIcon,
    'emoji-heart-yellow': HeartYellowIcon,
    'emoji-otter': OtterIcon,
    'emoji-plusone': PlusoneIcon,
    'emoji-poop-scared': PoopScaredIcon,
    'emoji-poop-fine': PoopFineIcon,
    'emoji-rainbow': RainbowIcon,
    'emoji-rainbowheart': RainbowheartIcon,
    'emoji-rocket': RocketIcon,
    'emoji-shark': SharkIcon,
    'emoji-sloth-face-smile': SlothFaceSmileIcon,
    'emoji-sparkles': SparklesIcon,
    'emoji-star': StarIcon,
    'emoji-sun': SunIcon,
    'face-angry': FaceAngryIcon,
    'face-celebrate': FaceCelebrateIcon,
    'face-eyes-stars': FaceEyesStarsIcon,
    'face-fart': FaceFartIcon,
    'face-flushed': FaceFlushedIcon,
    'face-heartbroken': FaceHeartbrokenIcon,
    'face-laughing-cry': FaceLaughingCryIcon,
    'face-laughing-hard': FaceLaughingHardIcon,
    'face-laughing': FaceLaughingIcon,
    'face-sad-eyes': FaceSadEyesIcon,
    'face-sad-tear': FaceSadTearIcon,
    'face-sad': FaceSadIcon,
    'face-scared-ghost': FaceScaredGhostIcon,
    'face-sick-green': FaceSickGreenIcon,
    'face-sleepy': FaceSleepyIcon,
    'face-smile-sweat': FaceSmileSweatIcon,
    'face-smirk': FaceSmirkIcon,
    'face-sunglasses': FaceSunglassesIcon,
    'face-surprised': FaceSurprisedIcon,
    'face-teeth-unsure': FaceTeethUnsureIcon,
    'face-thinking': FaceThinkingIcon,
    'face-tongue-out-wink': FaceTongueOutWinkIcon,
    'face-tongue-out-yum': FaceTongueOutYumIcon,
    'face-unsure': FaceUnsureIcon,
};
